import { docReady } from '../helpers/docReady';
import '../../styles/templates/article.scss';
docReady(() => {
    console.log('Article Template JS Ready');
});
